import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getVehicles as getVehiclesApi,
  getVehiclesGetFilters as getVehiclesGetFiltersApi,
  getVehiclesGetFiltersExport as getVehiclesGetFiltersExportApi,
  addNewVehicle as addNewVehicleApi,
  updateVehicle as updateVehicleApi,
  deleteVehicle as deleteVehicleApi,
  getClientVehicles as getClientVehiclesApi,
} from "../../helpers/realbackend_helper";

export const getVehicles = createAsyncThunk("vehicle/getVehicles", async () => {
  try {
    const response = await getVehiclesApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const getVehiclesGetFilters = createAsyncThunk(
  "vehicle/getVehiclesGetFilters",
  async (filters, thunkAPI) => {
    try {
      const response = await getVehiclesGetFiltersApi(filters);
      return response;
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      // axios interceptor нь ихэвчлэн шууд string reject хийдэг тул үүнийг
      // эхэнд шалгана. Өмнө нь error.response/-message хоёулаа undefined
      // болж, бодит алдаа "Error fetching vehicles" болж нуугдаж байсан.
      return thunkAPI.rejectWithValue(
        (typeof error === "string" && error) ||
          error?.response?.data?.message ||
          error?.message ||
          "Error fetching vehicles"
      );
    }
  }
);

export const getVehiclesGetFiltersExport = createAsyncThunk(
  "vehicle/getVehiclesGetFiltersExport",
  async (filters, thunkAPI) => {
    try {
      const response = await getVehiclesGetFiltersExportApi(filters);
      return response;
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      // axios interceptor нь ихэвчлэн шууд string reject хийдэг тул үүнийг
      // эхэнд шалгана. Өмнө нь error.response/-message хоёулаа undefined
      // болж, бодит алдаа "Error fetching vehicles" болж нуугдаж байсан.
      return thunkAPI.rejectWithValue(
        (typeof error === "string" && error) ||
          error?.response?.data?.message ||
          error?.message ||
          "Error fetching vehicles"
      );
    }
  }
);

export const addNewVehicle = createAsyncThunk(
  "vehicle/addNewVehicle",
  async (vehicle) => {
    try {
      const response = addNewVehicleApi(vehicle);
      toast.success("Автомашины мэдээллийг амжилттай нэмлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Автомашины мэдээллийг нэмэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateVehicle = createAsyncThunk(
  "vehicle/updateVehicle",
  async (vehicle) => {
    try {
      const response = updateVehicleApi(vehicle);
      toast.success("Автомашины мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Автомашины мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteVehicle = createAsyncThunk(
  "vehicle/deleteVehicle",
  async (vehicle) => {
    try {
      const response = deleteVehicleApi(vehicle);
      toast.success("Автомашины мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });
      return { vehicle, ...response };
    } catch (error) {
      toast.error("Автомашины мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const getClientVehicles = createAsyncThunk(
  "vehicle/getClientVehicles",
  async ({ company_name }, { rejectWithValue }) => {
    try {
      const response = await getClientVehiclesApi(company_name);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch VFees");
    }
  }
);
